import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Clock, LogOut } from "lucide-react";

const PendingApprovalPage = () => {
  const { user, logout } = useAuth();

  // Try to determine what team/org they're waiting for
  const teamName = user?.team_id ? "your team" : "your organization";

  return (
    <div data-testid="pending-approval-page" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--dark-bg)', padding: 24,
    }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          background: 'rgba(255, 152, 0, 0.1)', border: '2px solid rgba(255, 152, 0, 0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px',
        }}>
          <Clock size={36} style={{ color: '#ff9800' }} />
        </div>

        <h1 data-testid="pending-title" style={{
          fontFamily: "'Outfit', sans-serif", fontSize: 28, fontWeight: 700, marginBottom: 12,
        }}>Awaiting Approval</h1>

        <p style={{ color: 'var(--text-secondary)', fontSize: 15, lineHeight: 1.6, marginBottom: 8 }}>
          Your account is pending approval from <strong style={{ color: 'var(--cyan)' }}>{teamName}</strong>.
        </p>
        <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6, marginBottom: 32 }}>
          {user?.role === "org_admin"
            ? "A League Administrator needs to approve your organization admin access."
            : "An Organization Administrator needs to approve your access to view team content."
          }
        </p>

        <div className="glass-card" style={{ padding: 20, marginBottom: 24 }}>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>Signed in as</p>
          <p style={{ fontSize: 16, fontWeight: 600 }}>{user?.name}</p>
          <p style={{ color: 'var(--cyan)', fontSize: 13 }}>{user?.email}</p>
          <span style={{
            display: 'inline-block', marginTop: 8,
            background: 'rgba(255, 152, 0, 0.15)', color: '#ff9800',
            fontSize: 11, fontWeight: 600, padding: '3px 12px', borderRadius: 12,
          }}>PENDING</span>
        </div>

        <button data-testid="pending-logout-btn" onClick={logout} style={{
          background: 'rgba(244,67,54,0.1)', border: '1px solid rgba(244,67,54,0.2)',
          borderRadius: 8, color: '#f44336', fontSize: 14, fontWeight: 600,
          padding: '12px 28px', cursor: 'pointer', display: 'inline-flex',
          alignItems: 'center', gap: 8, fontFamily: "'DM Sans', sans-serif",
        }}>
          <LogOut size={16} /> Sign Out
        </button>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
